import React from 'react';
import { useParams } from 'react-router-dom';
import EigentuemerListeSeite from './liste/EigentuemerListeSeite';
import EigentuemerSeite from './detail/EigentuemerSeite';

interface EigentuemerListeProps {
  initialEigentuemerId?: string | null;
  onClearInitial?: () => void;
  onNavigateToObjekt?: (id: string) => void;
}

/** Bereich „Eigentümer“ im neuen Design (Handoff Eigentümer): Liste und Detail (/admin/eigentuemer/:eigentuemerId). */
const EigentuemerListe: React.FC<EigentuemerListeProps> = ({ initialEigentuemerId, onClearInitial, onNavigateToObjekt }) => {
  const { eigentuemerId } = useParams<{ eigentuemerId: string }>();
  // key: beim Wechsel des Eigentümers neu aufbauen – offenes Panel schließt, Gruppe steht wieder auf „Alle“
  if (eigentuemerId) return <EigentuemerSeite key={eigentuemerId} eigentuemerId={eigentuemerId} onNavigateToObjekt={onNavigateToObjekt} />;
  return <EigentuemerListeSeite initialEigentuemerId={initialEigentuemerId} onClearInitial={onClearInitial} />;
};

export default EigentuemerListe;
